import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Label,
  makeStyles,
  Dropdown,
  Toaster,
  Option,
  OptionOnSelectData,
  Tooltip,
  Spinner,
} from "@fluentui/react-components";
import React, { useEffect, useRef, useState } from "react";
import apiServices from "../../service";
import { useSelector } from "react-redux";
import {
  Dismiss24Regular,
  AttachRegular,
  Edit24Filled,
} from "@fluentui/react-icons";
import ReactQuill from "react-quill";
import OverlayLoader from "../../components/OverlayLoader";
import { generateUUID, getUserId } from "../../utils";
import ASCButton from "../../components/Button";
import DynamicDropzone from "../../components/DynamicDropzone/Dropzone";
type propsType = {
  openSendMailDialog?: any;
  isSendMailDialogOpen: any;
  closeSendMailDialog: any;
  reloadList?: any;
  notify: any;
  selectClient: { customer_id: string; first_names: string; last_name: string };
};

type selectedValue = {
  customer_id: string;
  first_names: string;
  last_name: string;
  email: string;
};

interface Template {
  code: string;
  title: string;
  description: string;
  body: string;
}
const modules = {
  toolbar: false,
};
const useStyles = makeStyles({
  listbox: {
    maxHeight: "40vh !important",
    overflowY: "auto",
  },
});

function SendMail(props: propsType) {
  const styles = useStyles();
  const [clients, setClients] = useState<selectedValue[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [templateLoading, setTemplateLoading] = useState<boolean>(false);
  const [selectedClient, setSelectedClient] = useState<selectedValue[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<string>("");
  const [template, setTemplate] = useState<Template[]>([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState<string>("");
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [messageBody, setMessageBody] = useState<any>([]);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [showCancel, setShowCancel] = useState<boolean>(false);
  const { userProfileInfo } = useSelector((state: any) => state.authUser);
  const [enableEdit, setEnableEdit] = useState<boolean>(false);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [initialMessageBody, setInitialMessageBody] = useState<string>("");
  const [rawFiles, setRawFiles] = useState<File[]>([]);
  const [scannedFiles, setScannedFiles] = useState<any[]>([]);
  const attachInputRef = useRef<HTMLInputElement>(null);
  const userId = getUserId();

  const isScanning = scannedFiles.some(
    (f) => f.status === "uploading" || f.status === "scanning"
  );

  // const handleDropdownChangetemplate = (
  //   event: React.FormEvent<HTMLDivElement>,
  //   item?: any,
  // ): void => {
  //   if (item) {
  //     setSelectedTemplate(item.text);
  //     setSelectedTemplateId(item.key);
  //     // getCreateContent(item.key, selectedOptions[0]);
  //     generatePreviewList(item.key, props.selectClient.customer_id);
  //   }
  // };
  const handleDropdownChangetemplate = (
    _event: React.SyntheticEvent,
    data: OptionOnSelectData,
  ) => {
    const templateCode = data.optionValue as string;
    const templateTitle = data.optionText as string;
    setSelectedTemplate(templateTitle);
    setSelectedTemplateId(templateCode);
    setMessageBody([]);
    if (templateCode && props.selectClient?.customer_id) {
      getMessageBody(templateCode, props.selectClient.customer_id);
    }
  };

  const getTemplateList = () => {
    setTemplateLoading(true);
    apiServices.TemplateEngine.getEmailTemplate()
      .then((response: any) => {
        if (!response.data.isError) {
          if (response.data) {
            setTemplate(response.data);
          }
        }
      })
      .catch((e: Error) => {
        console.log(e);
      })
      .finally(() => setTemplateLoading(false));
  };
  const generateMessage = (
    template: string,
    replacements: { [key: string]: string },
  ) => {
    let result = template;

    for (const [placeholder, value] of Object.entries(replacements)) {
      const regex = new RegExp(`{{${placeholder}}}`, "g");
      result = result.replace(regex, value);
    }
    return result;
  };
  const generatePreviewList = (templateId: string, client: any) => {
    if (templateId !== undefined && client !== undefined) {
      getMessageBody(templateId, props.selectClient.customer_id);
    }
  };

  const getMessageBody = (templateId: string, customer: any) => {
    setLoading(true);
    apiServices.notification
      .createContent(templateId, props.selectClient.customer_id)
      .then((response: any) => {
        setLoading(false);
        if (response.data) {
          const { Body, Subject, Placeholders } = response.data;
          const message = response.data.templateContent;

          // Set both the current message body and the initial message body
          const newPreviewItem = {
            body: message,
            subject: Subject,
            placeholders: Placeholders,
            customer,
            edited: false,
          };
          setMessageBody([newPreviewItem]);
          setInitialMessageBody(message); // Store the initial body
        }
      })
      .catch((e: Error) => {
        setLoading(false);
        console.log(e);
      });
  };

  const NOTIFICATION_ID = generateUUID();

  const resetPage = () => {
    setSelectedTemplate("");
    setSelectedTemplateId("");
    setShowPopup(false);
    setShowConfirmation(false);
    setSelectedOptions([]);
    setSelectedClient([]);
    setMessageBody([]);
    clearFiles();
    props.reloadList(true);
  };
  const clearFiles = () => {
    setRawFiles([]);
    setScannedFiles([]);
  };

  const handleSendMail = async () => {
    const formData = new FormData();
    formData.append("customerId", props.selectClient.customer_id);
    formData.append("subject", selectedTemplate);
    formData.append("cc", userProfileInfo.user_email);
    formData.append("from", userProfileInfo.user_email);
    formData.append("body", messageBody[0]?.body);
    formData.append("notificationId", NOTIFICATION_ID);

    const objectIds = scannedFiles
      .filter((f) => f.objectId)
      .map((f) => f.objectId)
      .join(",");
    if (objectIds) formData.append("objectIds", objectIds);

    try {
      const res = await apiServices.notification.sendEmail(formData);
      props.notify(res.data.message);
      resetPage();
      setShowPopup(false);
      setShowConfirmation(false);
      setShowCancel(false);
      props.closeSendMailDialog();
    } catch (err) {
      props.notify("Failed to send email. Please try again.");
    }
  };
  const handleCancel = (): void => {
    setShowPopup(false);
    setShowConfirmation(false);
    setShowCancel(true);
  };
  const handleContinue = (): void => {
    setShowPopup(false);
    setShowConfirmation(true);
  };

  const handleConfirmation = (confirmed: boolean): void => {
    setShowConfirmation(false);
    if (confirmed) {
      resetPage();
    }
  };

  const cancelConfirmation = () => {
    setShowCancel(false);
    props.closeSendMailDialog();
  };

  useEffect(() => {
    getTemplateList();
  }, []);
  return (
    <>
      {/* <Toaster toasterId={toasterId} position="top-end" timeout={5000} /> */}
      <Dialog open={props.isSendMailDialogOpen}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle
              action={
                <DialogTrigger action="close">
                  <ASCButton
                    shape="rounded"
                    appearance="subtle"
                    aria-label="close"
                    icon={
                      <Dismiss24Regular onClick={props.closeSendMailDialog} />
                    }
                  />
                </DialogTrigger>
              }
            >
              Send Mail
            </DialogTitle>
            <DialogContent>
              <div className="send_mail_popup">
                <Label className="label">Selected Client</Label>
                <Label>
                  {props.selectClient.first_names}{" "}
                  {props.selectClient.last_name}
                </Label>
                <Label className="label">Select Template</Label>

                <Dropdown
                  listbox={{ className: styles.listbox }}
                  data-testid="template-dropdown"
                  placeholder={templateLoading ? "Loading templates..." : "Select Template"}
                  disabled={templateLoading}
                  value={selectedTemplate}
                  onOptionSelect={handleDropdownChangetemplate}
                  button={templateLoading ? <Spinner size="tiny" /> : undefined}
                >
                  {template.map((templates: Template) => (
                    <Option
                      key={templates.code}
                      value={templates.code}
                      text={templates.title}
                    >
                      {templates.title}
                    </Option>
                  ))}
                </Dropdown>
              </div>
              {selectedTemplate.length > 0 && (
                <>
                  <div className="send_mail_popup">
                    <Label className="label">From</Label>
                    <Label>{userProfileInfo.user_email}</Label>
                    <Label className="label">Cc</Label>
                    <Label>{userProfileInfo.user_email}</Label>
                    <Label className="label">Subject</Label>
                    <Label>{selectedTemplate}</Label>
                  </div>
                  <div className="message_body">
                    {enableEdit ? (
                      <>
                        <div className="flex-end">
                          <input
                            ref={attachInputRef}
                            type="file"
                            multiple
                            style={{ display: "none" }}
                            onChange={(e) => {
                              const selected = Array.from(e.target.files || []);
                              if (selected.length > 0) {
                                setRawFiles(prev => [...prev, ...selected].slice(0, 5));
                                setSelectedItemId(props.selectClient.customer_id);
                              }
                              e.target.value = "";
                            }}
                          />
                          <Tooltip
                            content={
                              rawFiles.length >= 5
                                ? "Maximum 5 files allowed"
                                : isScanning
                                  ? "Please wait for scanning to complete"
                                  : "Attach files (max 5)"
                            }
                            relationship="description"
                          >
                            <Button
                              appearance="subtle"
                              icon={<AttachRegular />}
                              disabled={rawFiles.length >= 5}
                              onClick={() => attachInputRef.current?.click()}
                            />
                          </Tooltip>
                        </div>
                        <ReactQuill
                          value={messageBody[0]?.body}
                          onChange={(value) => {
                            setMessageBody([
                              { ...messageBody[0], body: value },
                            ]);
                          }}
                          modules={modules}
                          style={{ border: "none", padding: 0 }}
                        />
                        {rawFiles.length > 0 && (
                          <DynamicDropzone
                            style={{ marginTop: "8px" }}
                            multiple={true}
                            maxFiles={5}
                            externalFiles={rawFiles}
                            onFilesChange={(files: any) => {
                              setScannedFiles(files);
                            }}
                            onFileRemoved={(file: File) => {
                              setRawFiles(prev => prev.filter(f => f !== file));
                            }}
                            userId={userId}
                          />
                        )}
                        <div className="action_buttons">
                          <ASCButton
                            shape="rounded"
                            className="asc-button-primary"
                            appearance="primary"
                            onClick={() => {
                              clearFiles();
                              setEnableEdit(false);
                              setSelectedItemId("");
                              setMessageBody([{ body: initialMessageBody }]);
                            }}
                            size="medium"
                            label="Cancel"
                          />
                          <ASCButton
                            shape="rounded"
                            appearance="secondary"
                            disabled={isScanning}
                            onClick={() => {
                              setEnableEdit(false);
                              setSelectedItemId("");
                              setMessageBody((prevList: any) =>
                                prevList.map((item: any, i: number) =>
                                  i === 0 ? { ...item, edited: true } : item,
                                ),
                              );
                            }}
                            size="medium"
                            label={isScanning ? "Scanning..." : "Save"}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="flex-end">
                          <ASCButton
                            shape="rounded"
                            appearance="subtle"
                            data-testid="edit-button"
                            onClick={() => {
                              setEnableEdit(true);
                              setSelectedItemId(props.selectClient.customer_id);
                            }}
                            icon={<Edit24Filled />}
                          />
                        </div>
                        <OverlayLoader
                          isLoading={loading}
                          data-testid="overlay-loader"
                        />
                        <div
                          dangerouslySetInnerHTML={{
                            __html: messageBody[0]?.body,
                          }}
                        ></div>
                        <div className="file_upload_list">
                          {scannedFiles
                            .filter((f) => f.status === "success")
                            .map((f: any, index: number) => (
                              <div
                                className="file_upload_detail"
                                key={index}
                              >
                                <div>
                                  <p>{f.file?.name}</p>
                                  <span style={{ fontSize: 12 }}>
                                    {((f.file?.size || 0) / 1024).toFixed(2)} KB
                                  </span>
                                </div>
                              </div>
                            ))}
                        </div>
                      </>
                    )}
                  </div>
                  {!enableEdit && (
                    <div className="message_buttons">
                      <ASCButton
                        shape="rounded"
                        appearance="secondary"
                        onClick={handleCancel}
                        label="Cancel"
                      />
                      <ASCButton
                        shape="rounded"
                        className="asc-button-primary"
                        appearance="primary"
                        disabled={isScanning}
                        onClick={handleContinue}
                        label={isScanning ? "Scanning..." : "Send"}
                      />
                    </div>
                  )}
                </>
              )}
            </DialogContent>
          </DialogBody>
        </DialogSurface>
      </Dialog >
      {showCancel && (
        <Dialog
          open={showCancel}
          onOpenChange={(event, data) => setShowCancel(data.open)}
        >
          <DialogSurface>
            <DialogContent>
              <DialogTitle>Are you sure you want to cancel?</DialogTitle>

              <div className="message_buttons">
                <ASCButton
                  shape="rounded"
                  appearance="primary"
                  className="asc-button-primary"
                  onClick={() => setShowCancel(false)}
                  label="No"
                />
                <ASCButton
                  shape="rounded"
                  appearance="secondary"
                  onClick={cancelConfirmation}
                  label="Yes"
                />
              </div>
            </DialogContent>
          </DialogSurface>
        </Dialog>
      )
      }
      {
        showConfirmation && (
          <Dialog
            open={showConfirmation}
            onOpenChange={(event, data) => setShowConfirmation(data.open)}
          >
            <DialogSurface>
              <DialogContent>
                <DialogTitle>Confirmation for sending mail</DialogTitle>

                <div className="message_buttons">
                  <ASCButton
                    shape="rounded"
                    appearance="secondary"
                    onClick={() => handleConfirmation(false)}
                    label="Cancel"
                  />
                  <ASCButton
                    shape="rounded"
                    className="asc-button-primary"
                    appearance="primary"
                    onClick={() => handleSendMail()}
                    label="Send Email"
                  />
                </div>
              </DialogContent>
            </DialogSurface>
          </Dialog>
        )
      }
    </>
  );
}

export default SendMail;
